import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20flowing%20warm%20golden%20and%20crimson%20gradient%20composition%20with%20soft%20curves%2C%20luxurious%20professional%20atmosphere%2C%20clean%20smooth%20shapes%2C%20no%20text%2C%20no%20people%2C%20editorial%20quality%2C%20warm%20ambient%20lighting%2C%20premium%20elegant%20aesthetic&width=1800&height=600&seq=cta-bg-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 via-foreground-900/70 to-foreground-900/85"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50">
          准备好开始了吗？
        </h2>
        <p className="mt-4 text-base text-background-100/80 leading-relaxed">
          访问 https www kaiyun com 官方入口，即刻体验安全、便捷的在线服务
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://aiubo.cn"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            访问官方网站
          </a>
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-all text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-guide-line"></i>
            浏览使用教程
          </Link>
        </div>
      </div>
    </section>
  );
}